import $ from 'jquery';
import Cookies from 'js-cookie';

/*
 * List of Dom Elements
 */

const elements = {
  $cookieNotice: $('.js-cookie'),
  $cookieButton: $('.js-cookie-btn'),
};

function init() {
  // If cookie doesnt exist show banner
  if (!Cookies.get('msCookie')) elements.$cookieNotice.addClass('is-visible');
  // Set cookie - opt-in in user doesnt need to click button
  Cookies.set('msCookie', 'true', {
    expires: 365,
    path: '/',
  });
  // Remove banner
  elements.$cookieButton.on('click', () => {
    elements.$cookieNotice.removeClass('is-visible');
  });
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/default/notices/cookie/mando-ui.cookie.js